import BasePcNoEditModules from '@src/slide/application/no-edit/entry/base/editor/pc';
import { PluginConfig } from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { SHARE_PC_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/share/toc/pc/plugin-config';
import { AUTH_PC_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/auth/toc/pc/plugin-config';

export default class NoEditModules extends BasePcNoEditModules {
    protected getAuthPluginConfig(): PluginConfig[] {
        return [
            AUTH_PC_PLUGIN_CONFIG,
        ];
    }

    protected getSharePcPluginConfig(): PluginConfig {
        return SHARE_PC_PLUGIN_CONFIG;
    }
}
